export default "__VITE_ASSET__BehMPEw2__"